module.exports = __webpack_public_path__ + "img/avada-food-logo-mob-2x.94515a57.png";